import React from 'react';

import {SeparatedChunk} from '../../shared';
import {spanStatusAggregationOptions} from '../constants';
import {type AggregationFunction, type ComparisonOperator} from '../types';
import {AggregationThresholdFields} from './AggregationThresholdFields';

type SpanErrorRateConfigProps = {
  aggregationFunction: AggregationFunction;
  threshold: string;
  operator: ComparisonOperator;
  onAggregationFunctionChange: (value: AggregationFunction) => void;
  onThresholdChange: (value: string) => void;
  onOperatorChange: (operator: ComparisonOperator) => void;
  hasThresholdError: boolean;
};

/**
 * Error-rate config for spans alerts: percentage/count of spans whose
 * status_code is ERROR. No status-value selector (error is implied), so it
 * never emits status_match_value.
 */
export const SpanErrorRateConfig = ({
  aggregationFunction,
  threshold,
  operator,
  onAggregationFunctionChange,
  onThresholdChange,
  onOperatorChange,
  hasThresholdError,
}: SpanErrorRateConfigProps) => (
  <SeparatedChunk>
    <div className="font-semibold">Error rate</div>
    <div className="mt-4 flex flex-col gap-12">
      <AggregationThresholdFields
        aggregationFunction={aggregationFunction}
        threshold={threshold}
        operator={operator}
        onAggregationFunctionChange={onAggregationFunctionChange}
        onThresholdChange={onThresholdChange}
        onOperatorChange={onOperatorChange}
        hasThresholdError={hasThresholdError}
        aggregationOptions={spanStatusAggregationOptions}
      />
    </div>
  </SeparatedChunk>
);
